<div *ngIf="isAppoRequestIconEnabled" class="appo-request-icon">
  <ng-container *ngIf="!isMobileWidth; else mobileAppoRequestIcon">
    <button siPreventDoubleClick
            class="si-button_main"
            type="button"
            (click)="onClickButtonAppoRequest()">
      <div class="d-flex align-items-center px-2">
        <i class="icosun-appointment_new"></i>
        <span class="ml-2">{{'SI_APPOINTMENT_REQUEST' | translate}}</span>
      </div>
    </button>
  </ng-container>
  <ng-template #mobileAppoRequestIcon>
    <button siPreventDoubleClick
            class="si-button_link-thick"
            pTooltip="{{'SI_APPOINTMENT_REQUEST' | translate}}"
            tooltipPosition="bottom"
            type="button"
            (click)="onClickButtonAppoRequest()">
      <div class="d-flex align-items-center">
        <i class="icosun-appointment_new"></i>
        <span class="ml-2">{{'SI_APPOINTMENT_REQUEST' | translate}}</span>
      </div>
    </button>
  </ng-template>
</div>
